import { AbstractControl, ValidatorFn } from '@angular/forms';

export class ValidationsHelper {

    static minLengthArray(min: number) {
        return (control: AbstractControl): {[key: string]: any} => {
            if (control.value.length >= min) {
                return null;
            }
            return { 'minLengthArray': {valid: false }};
        }
    }

    static telephoneRegex() {
        const regex = new RegExp('^0[1-9][0-9]{8}$'); //new RegExp('^\d{10}$');

        return (control: AbstractControl): {[key: string]: any} => {
            if (!control.value || regex.test(control.value)) {
                return null;
            }
            return { 'telephoneFormat': {valid: false }};
        };
    }
    static telephonePortableRegex() {
        const regex = new RegExp('^0[6-7][0-9]{8}$');

        return (control: AbstractControl): {[key: string]: any} => {
            if (!control.value || regex.test(control.value)) {
                return null;
            }
            return { 'telephonePortableFormat': {valid: false }};
        };
    }

    static emailRegex() {
        // const regex = new RegExp('(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)');
        // const regex = new RegExp( `(^((\\w[^\\W]+)[\.\\-]?){1,}\@(([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3})|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$)`); /!\ n'accepte pas a.bcd@efg.com
        const regex = new RegExp(`(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)`);
        return (control: AbstractControl): {[key: string]: any} => {
            if (!control.value || regex.test(control.value)) {
                return null;
            }
            return { 'emailFormat': {valid: false }};
        };
    }




}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/helpers/validations.helper.ts